// src/components/progress-indicator/progress-indicator.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSIconFragment on Icon {\n    description\n    id\n    size\n    theme\n    title\n    withBackground\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSIllustrationFragment on Illustration {\n    description\n    link: url\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSMarkFragment on Mark {\n    description\n    id\n    url {\n      value\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  fragment UIGraphicFragment on UIGraphic {\n    ...EGDSIconFragment\n    ...EGDSMarkFragment\n    ...EGDSIllustrationFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSProgramBadgeFragment on EGDSProgramBadge {\n    accessibility\n    graphic {\n      ...UIGraphicFragment\n    }\n    text\n    theme\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ProgressIndicatorInstallmentPlanFragment on InstallmentPlanPlacement {\n    totalPrice\n    subTextRequired\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  query ProgressIndicatorQuery(\n    $context: ContextInput!\n    $multiItemSessionId: String\n    $journeyContinuationId: String\n    $multiItemPriceToken: String\n    $lockupPrice: MoneyInput\n    $savingsPrice: MoneyInput\n    $originalBookingId: String\n    $additionalChangeQueryParams: AdditionalChangeQueryParamsInput\n  ) {\n    multiItemStepIndicator(\n      context: $context\n      multiItemSessionId: $multiItemSessionId\n      journeyContinuationId: $journeyContinuationId\n      multiItemPriceToken: $multiItemPriceToken\n      lockupPrice: $lockupPrice\n      savingsPrice: $savingsPrice\n      originalBookingId: $originalBookingId\n      additionalChangeQueryParams: $additionalChangeQueryParams\n    ) {\n      steps {\n        a11yLabel\n        currentStep\n        changeSelection {\n          action {\n            analytics {\n              linkName\n              referrerId\n            }\n            resource {\n              ... on HttpURI {\n                value\n                relativePath\n              }\n            }\n          }\n          label\n          a11yLabel\n        }\n        label {\n          ... on FlightStepIndicatorLabel {\n            text\n            origin\n            destination\n            icon {\n              description\n              withBackground\n              size\n              id\n            }\n          }\n          ... on SimpleStepIndicatorLabel {\n            text\n            detailText\n          }\n        }\n      }\n      priceLockup {\n        a11yPrice\n        lockupPrice\n        badge {\n          ...EGDSProgramBadgeFragment\n        }\n        priceSubtextStandard\n        strikeThroughPrice\n        strikeThroughDialogText\n        installmentPlanPlacement {\n          ...ProgressIndicatorInstallmentPlanFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
import React7 from "react";
import { gql as gql7, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
// ../internal/src/components/egds-program-badge/egds-program-badge.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { UitkBadgeProgram } from "uitk-react-badge";
// ../internal/src/components/ui-graphic/ui-graphic.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
// ../internal/src/components/egds-icon/egds-icon.tsx
import React from "react";
import { gql } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
var fragment = gql(_templateObject());
var EGDSIcon = function(param) {
    var data = param.data, defaultIconSize = param.defaultIconSize, defaultIconTheme = param.defaultIconTheme;
    var description = data.description, id = data.id, size = data.size, title = data.title, theme = data.theme, withBackground = data.withBackground;
    return /* @__PURE__ */ React.createElement(UitkIcon, {
        description: description,
        id: id,
        name: id,
        size: size ? UitkIconSize[size] : defaultIconSize,
        title: title !== null && title !== void 0 ? title : void 0,
        theme: theme !== null && theme !== void 0 ? theme : defaultIconTheme,
        shadow: Boolean(withBackground)
    });
};
EGDSIcon.displayName = "EGDSIcon";
EGDSIcon.fragment = fragment;
// ../internal/src/components/egds-illustration/egds-illustration.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkIllustrations } from "uitk-react-illustrations";
var fragment2 = gql2(_templateObject1());
var EGDSIllustration = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React2.createElement(UitkIllustrations, {
        alt: data.description,
        url: data.link
    });
};
EGDSIllustration.displayName = "EGDSIllustration";
EGDSIllustration.fragment = fragment2;
// ../internal/src/components/egds-mark/edgs-mark.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkMark } from "uitk-react-mark";
var fragment3 = gql3(_templateObject2());
var EGDSMark = function(param) {
    var data = param.data, size = param.size;
    var _data_url;
    if (!data.url && !data.id) {
        return null;
    }
    return /* @__PURE__ */ React3.createElement(UitkMark, {
        description: data.description,
        id: data.id,
        name: data.id,
        size: size,
        url: (_data_url = data.url) === null || _data_url === void 0 ? void 0 : _data_url.value
    });
};
EGDSMark.displayName = "EGDSMark";
EGDSMark.fragment = fragment3;
// ../internal/src/components/ui-graphic/ui-graphic.tsx
var fragment4 = gql4(_templateObject3(), EGDSIcon.fragment, EGDSMark.fragment, EGDSIllustration.fragment);
var UIGraphic = function(param) {
    var data = param.data, markProps = param.markProps, iconProps = param.iconProps;
    switch(data.__typename){
        case "Icon":
            return /* @__PURE__ */ React4.createElement(EGDSIcon, _objectSpread({
                data: data
            }, iconProps));
        case "Mark":
            return /* @__PURE__ */ React4.createElement(EGDSMark, _objectSpread({
                data: data
            }, markProps));
        case "Illustration":
            return /* @__PURE__ */ React4.createElement(EGDSIllustration, {
                data: data
            });
        default:
            return null;
    }
};
UIGraphic.displayName = "UIGraphic";
UIGraphic.fragment = fragment4;
// ../internal/src/components/egds-program-badge/egds-program-badge.tsx
var fragment5 = gql5(_templateObject4(), UIGraphic.fragment);
var themeMap = {
    deal: "deal",
    member: "member",
    trip: "trip",
    supplierpromo: "supplierpromo",
    vmce: "vmc"
};
var EGDSProgramBadge = function(param) {
    var data = param.data, iconSize = param.iconSize;
    var accessibility = data.accessibility, graphic = data.graphic, text = data.text, theme = data.theme;
    if (!text || !theme) {
        return null;
    }
    return /* @__PURE__ */ React5.createElement(UitkBadgeProgram, {
        a11yText: accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
        text: text,
        theme: themeMap[theme]
    }, graphic && /* @__PURE__ */ React5.createElement(UIGraphic, {
        data: graphic,
        iconProps: {
            defaultIconSize: iconSize
        }
    }));
};
EGDSProgramBadge.displayName = "EGDSProgramBadge";
EGDSProgramBadge.fragment = fragment5;
// src/components/progress-indicator/progress-indicator.tsx
import { UitkIconSize as UitkIconSize3 } from "uitk-react-icons";
import { UitkProgressIndicator } from "uitk-react-progress-indicator";
import { UitkLineSkeleton } from "uitk-react-skeleton";
import { UitkSpacing } from "uitk-react-spacing";
// src/components/progress-indicator/__private__/progress-indicator-utils.ts
import { UitkIconSize as UitkIconSize2 } from "uitk-react-icons";
var _obj;
var iconSizeMapper = (_obj = {}, _defineProperty(_obj, "EXTRA_SMALL" /* EXTRA_SMALL */ , UitkIconSize2.EXTRA_SMALL), _defineProperty(_obj, "SMALL" /* SMALL */ , UitkIconSize2.SMALL), _defineProperty(_obj, "MEDIUM" /* MEDIUM */ , UitkIconSize2.MEDIUM), _defineProperty(_obj, "MEDIUM_LARGE" /* MEDIUM_LARGE */ , UitkIconSize2.LARGE), _defineProperty(_obj, "LARGE" /* LARGE */ , UitkIconSize2.LARGE), _defineProperty(_obj, "XLARGE" /* XLARGE */ , UitkIconSize2.XLARGE), _obj);
var getStepLabel = function(label) {
    switch(label.__typename){
        case "FlightStepIndicatorLabel":
            var _label_icon;
            return {
                text: label.text,
                origin: label.origin,
                destination: label.destination,
                icon: {
                    description: label.icon.description,
                    id: label.icon.id,
                    size: ((_label_icon = label.icon) === null || _label_icon === void 0 ? void 0 : _label_icon.size) ? iconSizeMapper[label.icon.size] : void 0
                }
            };
        default:
            var _label_detailText;
            return {
                text: label.text,
                detailText: (_label_detailText = label.detailText) !== null && _label_detailText !== void 0 ? _label_detailText : void 0
            };
    }
};
var _step_changeSelection;
var normalizedProgressIndicatorSteps = function(steps) {
    return steps.map(function(step) {
        return {
            a11yLabel: step.a11yLabel,
            changeSelection: (_step_changeSelection = step.changeSelection) !== null && _step_changeSelection !== void 0 ? _step_changeSelection : void 0,
            currentStep: step.currentStep,
            label: getStepLabel(step.label)
        };
    });
};
var _priceLockup_priceSubtextStandard, _priceLockup_strikeThroughPrice;
var normalizedPriceLockup = function(priceLockup) {
    return priceLockup ? {
        a11yPrice: priceLockup.a11yPrice,
        lockupPrice: priceLockup.lockupPrice,
        priceSubtextStandard: (_priceLockup_priceSubtextStandard = priceLockup.priceSubtextStandard) !== null && _priceLockup_priceSubtextStandard !== void 0 ? _priceLockup_priceSubtextStandard : void 0,
        strikeThroughPrice: (_priceLockup_strikeThroughPrice = priceLockup.strikeThroughPrice) !== null && _priceLockup_strikeThroughPrice !== void 0 ? _priceLockup_strikeThroughPrice : void 0
    } : void 0;
};
// src/components/progress-indicator/__private__/__fragments__/progress-indicator-installment-plan.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { InstallmentPlan } from "@shared-ui/retail-multi-item-installment-plan";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
var fragment6 = gql6(_templateObject5());
var ProgressIndicatorInstallmentPlan = function(param) {
    var _param_data = param.data, totalPrice = _param_data.totalPrice, subTextRequired = _param_data.subTextRequired;
    return /* @__PURE__ */ React6.createElement(UitkLayoutFlex, {
        justifyContent: "end",
        "data-stid": "progress-indicator-installment-plan"
    }, /* @__PURE__ */ React6.createElement(InstallmentPlan, {
        inputs: {
            multiItemSessionId: null,
            amount: totalPrice
        },
        alignment: "end",
        legalText: subTextRequired
    }));
};
ProgressIndicatorInstallmentPlan.fragment = fragment6;
ProgressIndicatorInstallmentPlan.displayName = "ProgressIndicatorInstallmentPlan";
// src/components/progress-indicator/progress-indicator.tsx
var __Query = gql7(_templateObject6(), EGDSProgramBadge.fragment, ProgressIndicatorInstallmentPlan.fragment);
var ProgressIndicator = function(props) {
    var inputs = props.inputs, skipSsr = props.skipSsr, changeLinkClickCallback = props.changeLinkClickCallback, showLoadingState = props.showLoadingState, errorCallback = props.errorCallback;
    var context = useBexApi().context;
    var variables = _objectSpreadProps(_objectSpread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading, previousData = _useQuery.previousData;
    if (loading && !previousData) {
        return showLoadingState ? /* @__PURE__ */ React7.createElement(React7.Fragment, null, /* @__PURE__ */ React7.createElement(UitkSpacing, {
            margin: {
                blockend: "three"
            },
            "data-stid": "progress-indicator-skeleton"
        }, /* @__PURE__ */ React7.createElement(UitkLineSkeleton, {
            animation: true,
            type: "primary"
        })), /* @__PURE__ */ React7.createElement(UitkLineSkeleton, {
            animation: true,
            type: "secondary"
        })) : /* @__PURE__ */ React7.createElement(UitkSpacing, {
            padding: "four"
        }, /* @__PURE__ */ React7.createElement("span", null));
    }
    var stepData = loading && previousData ? previousData : data;
    if (error || !stepData) {
        if (error && errorCallback) {
            errorCallback();
        }
        return null;
    }
    var _stepData_multiItemStepIndicator = stepData.multiItemStepIndicator, steps = _stepData_multiItemStepIndicator.steps, priceLockup = _stepData_multiItemStepIndicator.priceLockup;
    var getSecondaryContent = function() {
        var secondaryContent = [];
        if (priceLockup === null || priceLockup === void 0 ? void 0 : priceLockup.badge) {
            secondaryContent.push(/* @__PURE__ */ React7.createElement(EGDSProgramBadge, {
                data: priceLockup.badge,
                iconSize: UitkIconSize3.EXTRA_SMALL
            }));
        }
        return secondaryContent;
    };
    return /* @__PURE__ */ React7.createElement(React7.Fragment, null, /* @__PURE__ */ React7.createElement(UitkProgressIndicator, {
        steps: normalizedProgressIndicatorSteps(steps),
        priceLockup: normalizedPriceLockup(priceLockup),
        changeFlightOnClickCallback: changeLinkClickCallback,
        secondaryContent: getSecondaryContent()
    }), (priceLockup === null || priceLockup === void 0 ? void 0 : priceLockup.installmentPlanPlacement) && /* @__PURE__ */ React7.createElement(ProgressIndicatorInstallmentPlan, {
        data: priceLockup.installmentPlanPlacement
    }));
};
ProgressIndicator.displayName = "ProgressIndicator";
export { ProgressIndicator };
//# sourceMappingURL=index.js.map